/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {RenderItems, GridItem} from '../components/shared/render';
import NavAnchor from '../components/shared/nav-anchor';
import CompaniesUsingCard from '../components/cards/companies-using';
import IntegrationsWithCard from '../components/cards/integrations-with';
import PrivateStacksUseCard from '../components/cards/private-stacks-use';
import TeamsUseCard from '../components/cards/teams-use';
import GithubStatsCard from '../../../shared/library/cards/github-stats';
import SourceStatsCard from '../../../shared/library/cards/source-stats';
import DescriptionCard from '../../../shared/library/cards/description';
import Jobs from '../components/jobs';
import ComparisonCard from '../components/cards/comparison';
import Title from '../components/shared/title';
import QuestionPanelLarge from '../components/questions-answers/question-panel-large';
import {SIGN_IN_PATH} from '../../../shared/constants/paths';
import SignUpPanel from '../../../shared/library/panels/sign-up';
import SignUpPrivateStackshare from '../../../shared/library/advert/sign-up-private-stackshare';
import {NAVBAR_HEIGHT} from '../../../shared/style/dimensions';

const NAV_BAR_HEIGHT = 90;
const TOOL_CARD_STICKY_HEIGHT = 72;
const NAV_ANCHOR_OFFSET = NAV_BAR_HEIGHT + TOOL_CARD_STICKY_HEIGHT + NAVBAR_HEIGHT + 20;
const GET_ADVICE = 'getadvice';

const ExtraComponents1 = ({
  removeAfterCons,
  removeAfterAlternatives,
  num,
  tools,
  showGithubRepos,
  stackup,
  privateMode,
  userId,
  slug,
  setOpenAdviceModal,
  setSignupAction,
  navigate,
  showJobs,
  showPrivateStacksComparision,
  currentUser,
  showTeamComparision,
  showCompanyUsing,
  analyticsData,
  showIntegrations,
  showLoggedOutIntegrationsCta,
  stackupForPackages
}) => {
  return removeAfterCons ? (
    <>
      {removeAfterAlternatives && !stackupForPackages && (
        <>
          <NavAnchor id="stats" offset={NAV_ANCHOR_OFFSET} span={num} />
          <RenderItems tools={tools} num={num}>
            {tool => (
              <SourceStatsCard
                hackerNews={tool.hackernewsOnlineMentionsCount}
                reddit={tool.redditOnlineMentionsCount}
                stackOverflow={tool.stackOverflowOnlineMentionsCount}
              />
            )}
          </RenderItems>
        </>
      )}

      {!!(showGithubRepos && removeAfterAlternatives) && !stackupForPackages && (
        <RenderItems tools={tools} num={num}>
          {tool => (
            <GithubStatsCard
              url={tool.pressUrl}
              stars={tool.githubStarsCount}
              forks={tool.githubForksCount}
              lastUpdated={tool.githubUpdatedAt}
            />
          )}
        </RenderItems>
      )}

      {removeAfterAlternatives && (
        <>
          <NavAnchor id="description" offset={NAV_ANCHOR_OFFSET} span={num} />
          <RenderItems tools={tools} num={3}>
            {tool => (
              <DescriptionCard heading={`What is ${tool.name}?`} description={tool.description} />
            )}
          </RenderItems>
        </>
      )}

      {stackup && removeAfterAlternatives && !privateMode && (
        <GridItem span={num}>
          <QuestionPanelLarge
            hasBorder={false}
            userId={userId}
            panelPosition="middle"
            tools={tools}
            stackupName={stackup.title}
            stackupSlug={slug}
            onClick={() => {
              if (userId) {
                setOpenAdviceModal(true);
              } else {
                setSignupAction(GET_ADVICE);
                navigate(SIGN_IN_PATH);
              }
            }}
          />
        </GridItem>
      )}

      {stackup && showJobs && removeAfterAlternatives && (
        <GridItem span={num}>
          <NavAnchor id="jobs" offset={NAV_ANCHOR_OFFSET} span={num} />
          <Jobs slug={slug} tools={tools} />
        </GridItem>
      )}

      {stackup && stackup.content2 && removeAfterAlternatives && (
        <GridItem span={num}>
          <ComparisonCard content={stackup.content2} />
        </GridItem>
      )}

      {showPrivateStacksComparision && privateMode && removeAfterAlternatives && (
        <>
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`What private stacks use ${tool.name}?`} isPrivate={true} />}
          </RenderItems>

          <RenderItems tools={tools} num={num}>
            {tool => (
              <PrivateStacksUseCard
                disableScroll={!currentUser}
                slug={tool.slug}
                name={tool.name}
                items={tool.privateStacksList}
                title={`What private stacks use ${tool.name}?`}
                limitItems={30}
              />
            )}
          </RenderItems>
        </>
      )}

      {showTeamComparision && privateMode && removeAfterAlternatives && (
        <>
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`What teams use ${tool.name}?`} isPrivate={true} />}
          </RenderItems>

          <RenderItems tools={tools} num={num}>
            {tool => (
              <TeamsUseCard
                disableScroll={!currentUser}
                slug={tool.slug}
                name={tool.name}
                items={tool.teams}
                title={`What teams use ${tool.name}?`}
                limitItems={30}
              />
            )}
          </RenderItems>
        </>
      )}

      {showCompanyUsing && (
        <>
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`What companies use ${tool.name}?`} />}
          </RenderItems>

          <RenderItems
            tools={tools}
            num={num}
            emptySpaceComponent={
              privateMode || tools.length === 3 ? (
                false
              ) : (
                <SignUpPrivateStackshare
                  title={`See which teams inside your own company are using ${
                    tools.length === 1 ? tools[0].name : `${tools[0].name} or ${tools[1].name}`
                  }.`}
                  extraStyle={{marginTop: 0, border: 0}}
                />
              )
            }
          >
            {tool => (
              <CompaniesUsingCard
                disableScroll={!currentUser}
                slug={tool.slug}
                name={tool.name}
                items={tool.cachedCompanyStacksUsing}
                title={`What companies use ${tool.name}?`}
                limitItems={30}
              />
            )}
          </RenderItems>
        </>
      )}

      {!currentUser && stackup && showCompanyUsing && (
        <GridItem span={num}>
          <SignUpPanel
            heading="Sign up to get full access to all the companies"
            callout="Make informed product decisions"
            cta="Sign up now"
            section="Stackups"
            analyticsPayload={analyticsData}
          />
        </GridItem>
      )}
      {showIntegrations && (
        <>
          <NavAnchor id="integrations" offset={NAV_ANCHOR_OFFSET} span={num} />
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`What tools integrate with ${tool.name}?`} />}
          </RenderItems>

          <RenderItems tools={tools} num={num}>
            {tool => (
              <IntegrationsWithCard
                disableScroll={!currentUser}
                slug={tool.slug}
                name={tool.name}
                items={tool.cachedAllToolIntegrations}
                title={`What tools integrate with ${tool.name}?`}
                limitItems={20}
              />
            )}
          </RenderItems>
        </>
      )}

      {showLoggedOutIntegrationsCta && (
        <GridItem span={num}>
          <SignUpPanel
            heading="Sign up to get full access to all the tool integrations"
            callout="Make informed product decisions"
            cta="Sign up now"
            section="Stackups"
            analyticsPayload={analyticsData}
          />
        </GridItem>
      )}
    </>
  ) : (
    <></>
  );
};

ExtraComponents1.propTypes = {
  num: PropTypes.number,
  tools: PropTypes.array,
  privateMode: PropTypes.any,
  stackup: PropTypes.object,
  slug: PropTypes.string,
  removeAfterCons: PropTypes.bool,
  removeAfterAlternatives: PropTypes.bool,
  currentUser: PropTypes.any
};

export default ExtraComponents1;
